var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcChange = function SvgIcChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4168AB",
    stroke: "#4168AB",
    d: "M1.262 15.5v-.455H15.5v.454z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4168AB",
    d: "M11.688 0 2.286 8.975v4.116h4.312L16 4.116zM5.966 11.636H3.81V9.578l7.878-7.52 2.156 2.058z"
  })));
};
export default SvgIcChange;